import React, { useState } from "react";
import {
  SecessionContainer,
  SecessionNotice,
  SecessionReason,
  SecessionButton,
} from "./SecessionStyle";
import InfoSvg from "assets/icons/info-gray.svg";
import Modal from "components/common/modal/Modal";
import SecessionModalContent from "components/pages/myPage/SessionModalContent";
import axios from "axios";
import styled from "styled-components";
import BackLinkIcon from "assets/icons/left_arrow.svg";
import { useNavigate } from "react-router-dom";

const SECESSION_CONTENT_TEXT = "서비스 탈퇴가 완료되었습니다";
const REASON_TEXT = "탈퇴사유를 선택해주세요.";

const reasons = [
  "꽃집을 운영하거나, 준비하는데 있어서 유용한 정보를 제공하지 않아요.",
  "굳이 시장 가기 전에 온라인으로 정보를 알고 가는 것이 의미 없어요.",
  "입점 되지 않은 도매상이 너무 많아서 유용하다고 느끼지 못해요.",
  "서비스 내 오류가 많아서 사용하기 번거로워요.",
  "서비스 접근성이 떨어져서 자주 찾아오지 않게 돼요.",
];

const deleteUserInfo = {
  id: localStorage.getItem("userId"),
  socialId: localStorage.getItem("socialId"),
};

const Secession = () => {
  const [reason, setReason] = useState("");
  const [isAgree, setAgree] = useState(false);
  const [isOpenModal, setOpenModal] = useState(false);
  const closeModal = () => setOpenModal(false);
  const navigate = useNavigate();

  const deleteAccount = async () => {
    if (!deleteUserInfo.id || !deleteUserInfo.socialId) {
      console.error("not found user id, socialId");
      return;
    }
    await axios.delete("https://node.floway.co.kr/users");
    setOpenModal(true);
  };

  const onWithDrawal = () => {
    if (!isAgree || reason.length <= 0) {
      setOpenModal(true);
      return;
    }
    deleteAccount();
  };

  return (
    <SecessionContainer>
      <SecessionHeader>
        <img
          src={BackLinkIcon}
          alt="Back Link button"
          onClick={() => {
            navigate("/dashboard/search");
          }}
        />
        <h2>탈퇴하기</h2>
      </SecessionHeader>
      <SecessionNotice>
        <h2>서비스 탈퇴 안내 사항</h2>
        <div className="notice-box">
          <div className="notice-info">
            <img src={InfoSvg} alt="info-icon" />
            <p>서비스에서 제공하는 기능을 더 이상 사용하실 수 없어요.</p>
          </div>
          <div className="notice-info">
            <img src={InfoSvg} alt="info-icon" />
            <p>재가입하는 경우, 사업자 인증을 다시 해야해요.</p>
          </div>
          <div className="notice-info">
            <img src={InfoSvg} alt="info-icon" />
            <p>
              탈퇴 후에는 작성하신 게시글, 댓글(답글)을 삭제할 수 없어요. 미리
              확인해보세요.
            </p>
          </div>
        </div>
        <div className="notice-agree-box">
          <label htmlFor="notice-agree">
            <input
              type="checkbox"
              className="notice-checkbox"
              id="notice-agree"
              value={isAgree}
              onChange={() => setAgree((prev) => !prev)}
            />
            안내 사항을 모두 확인하였으며, 이에 동의합니다.
          </label>
        </div>
      </SecessionNotice>
      <SecessionReason>
        <h2>서비스 탈퇴 이유</h2>
        {reasons.map((item, index) => {
          return (
            <div className="reason-box" key={index}>
              <input
                type="radio"
                name="reason-selector"
                value={item}
                onChange={(e) => setReason(e.target.value)}
                disabled={!isAgree}
              />
              <label htmlFor={item}>{item}</label>
            </div>
          );
        })}
      </SecessionReason>
      <SecessionButton onClick={() => onWithDrawal()}>탈퇴하기</SecessionButton>
      <Modal isOpen={isOpenModal} onClose={closeModal}>
        <SecessionModalContent
          content={
            !isAgree || reason.length <= 0
              ? REASON_TEXT
              : SECESSION_CONTENT_TEXT
          }
          onClose={closeModal}
          isAgree={isAgree && reason.length >= 1}
        />
      </Modal>
    </SecessionContainer>
  );
};

export default Secession;

const SecessionHeader = styled.div`
  position: relative;

  img {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }

  h2 {
    text-align: center;
    font-size: 1.125rem;
    font-weight: bold;
    padding: 9px 0;
  }
`;
